import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DatasetDataPatchAPISchema } from '@rossum/mdh-api-client';
import { datasetApi, getDatasetRequestConfig } from '../api';
import { OPERATIONS_QUERY } from './useOperations';

export const usePatchDatasetRows = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      datasetName,
      operations,
    }: {
      datasetName: string;
      operations: DatasetDataPatchAPISchema['operations'];
    }) => {
      return datasetApi.patchDatasetDataApiV2DatasetsDatasetNameDataPatch(
        datasetName,
        { operations },
        getDatasetRequestConfig()
      );
    },
    onSuccess: () => {
      // The 202 response only queues the operation; the grid refetches via
      // the lastSuccessOperation query key once the operation finishes.
      queryClient.invalidateQueries({
        queryKey: OPERATIONS_QUERY,
      });
    },
  });
};
